<template>
  <div
    :key="url"
    class="calendly-inline-widget"
    :data-url="url"
  ></div>
</template>

<script>
export default {
  name: "CalendlyCall",
  computed: {
    url() {
      return `${this.$t('call-url')}&hide_event_type_details=0&hide_gdpr_banner=1&primary_color=317b87`;
    }
  },
  mounted() {
    this.load();
  },
  updated() {
    this.load();
  },
  methods: {
    load() {
      let externalScript = document.createElement("script");
      externalScript.setAttribute(
        "src",
        "https://assets.calendly.com/assets/external/widget.js"
      );
      document.head.appendChild(externalScript);
    }
  }
};
</script>

<style scoped>
.calendly-inline-widget {
  width: 650px;
  height: 1200px;
  overflow: hidden;
  margin-top: -50px;
}

@media only screen and (max-width: 960px) {
  .calendly-inline-widget {
    width: auto;
    margin-top: -30px;
    height: 1050px;
  }
}
@media only screen and (max-width: 700px) {
  .calendly-inline-widget {
    height: 1100px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
}
</style>
